module.exports = __webpack_public_path__ + "static/UnitedStates-6298a785cf64e846da0cc3f6359143c6.svg";